import { ENTRIES_LOADED } from '../constants';
import {makeInitialState, index} from './utils'

const initialState = makeInitialState()

export default function update(state = initialState, action) {
    switch (action.type) {
        case ENTRIES_LOADED:
            if(action.entries.film) return index(action.entries.film, state);
            break;
    }
    return state;
}
